/* eslint-disable */
// @ts-nocheck
import * as R from 'ramda';

import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';
import NotificationActions from './NotificationActions';
import B from 'bluebird';
import AppsActions from './AppsActions_LEGACY';

const FB_ROUTE = '/v1/facebook';

const SaveFBToken = new ReduxAsyncAction('FB_SAVE_TOKEN');
SaveFBToken.registerRequest((userID, accessToken) => {
  return dash_api.post(`${FB_ROUTE}/save-token`, { userID, accessToken }).then(() => ({ tokenHasSaved: true }));
});

export const SAVE_TOKEN = SaveFBToken.constants;
export const saveFBToken = SaveFBToken.request;

const GetFBUserData = new ReduxAsyncAction('FB_GET_USER_DATA');
GetFBUserData.registerRequest((userID, accessToken, needPermissions) => {
  return dash_api.post(`${FB_ROUTE}/save-token`, { userID, accessToken }).then(() => {
    return dash_api.post(`${FB_ROUTE}/session/user-data`, { userID }).then((userDataRes) => {
      if (!needPermissions) {
        return { userData: userDataRes.data };
      }
      return dash_api
        .post(`${FB_ROUTE}/session/user-permissions`, {
          accessToken,
          userID: userDataRes.data.id,
        })
        .then((permissionsRes) => {
          const combinedUserData = {
            ...userDataRes.data,
            permissions: permissionsRes.data.data,
          };
          return { userData: combinedUserData };
        });
    });
  });
});

export const GET_USER_DATA = GetFBUserData.constants;
export const getFBUserData = GetFBUserData.request;

const SaveFBConfig = new ReduxAsyncAction('FB_SAVE_CONFIG');
SaveFBConfig.registerRequest((userID, configToSave) => {
  return dash_api.post(`${FB_ROUTE}/session/save-config`, { userID, configToSave }).then(({ data }) => {
    data.neverConfigured = false;

    if (data.credentials.og_app_id) {
      AppsActions.saveSettings({ og_app_id: data.credentials.og_app_id });
    }

    NotificationActions.showNotification(`Facebook has been saved and enabled`, 'success');

    return data;
  });
});

// This action is used in the AdPartnerReducer, unlike all the others which
// are used in the FacebookReducer
export const FB_SAVE_CONFIG = SaveFBConfig.constants;
export const saveFBConfig = SaveFBConfig.request;

const LogoutFB = new ReduxAsyncAction('FB_LOGOUT');
LogoutFB.registerRequest(() => {
  const { FB } = window;
  // the facebook Web SDK may not be defined.
  if (FB) {
    const accessToken = FB.getAccessToken();
    const userID = FB.getUserID();
    if (accessToken) {
      FB.logout(() => {});
      if (userID) {
        return dash_api.post(`${FB_ROUTE}/revoke-permissions`, { userID, accessToken }).then(({ data }) => {
          return data;
        });
      }
    }
  }
  return B.resolve({});
});

export const FB_LOGOUT = LogoutFB.constants;
export const logoutFB = LogoutFB.request;

const CheckAttributionWindows = new ReduxAsyncAction('FB_CHECK_ATTRIBUTION_WINDOWS');
CheckAttributionWindows.registerRequest((adAccounts, savedCredentials) => {
  return dash_api
    .post(`${FB_ROUTE}/session/check-attribution-windows`, {
      adAccounts,
      savedCredentials,
      userID: savedCredentials.fb_user_id,
    })
    .then(({ data }) => {
      return data.reduce((dataByAccountID, current) => {
        return R.assoc(current.accountID, current.comparisonData, dataByAccountID);
      }, {});
    });
});

export const CHECK_ATTRIBUTION_WINDOWS = CheckAttributionWindows.constants;
export const checkAttributionWindows = CheckAttributionWindows.request;

/* -----------Onboarding flow actions:--------------------*/
// AD ACCOUNTS
const GetFBAdAccounts = new ReduxAsyncAction('FB_GET_AD_ACCOUNTS');
GetFBAdAccounts.registerRequest((userID) => {
  return dash_api.post(`${FB_ROUTE}/session/ad-account`, { userID }).then((res) => {
    return { adAccounts: res.data };
  });
});

export const GET_AD_ACCOUNTS = GetFBAdAccounts.constants;
export const getFBAdAccounts = GetFBAdAccounts.request;

// FACEBOOK APP INFO
const GetFBAppInfo = new ReduxAsyncAction('FB_GET_APP_INFO');
GetFBAppInfo.registerRequest((userID, FBAppID) => {
  return dash_api.post(`${FB_ROUTE}/session/app-info/${FBAppID}`, { userID }).then((res) => {
    return { FBAppInfo: res.data };
  });
});

export const GET_APP_INFO = GetFBAppInfo.constants;
export const getFBAppInfo = GetFBAppInfo.request;

const ValidateFBAppId = new ReduxAsyncAction('VALIDATE_FB_APP_ID');
ValidateFBAppId.registerRequest((appIdToValidate: string) => {
  return dash_api.post(`/v1/san-onboarding-validation/facebook`, { fb_app_id: appIdToValidate }).then(({ data }) => {
    return data;
  });
});

export const VALIDATE_FB_APP_ID = ValidateFBAppId.constants;
export const validateFBAppId = ValidateFBAppId.request;
